import moment from 'moment';

export default class DateUtilities {
  static getHoursTwoDigits(date) {
    const value = date.getHours();
    if (value < 10) {
      return (`0${ value }`);
    }
    return value.toString();
  }

  static getMinutesTwoDigits(date) {
    const value = date.getMinutes();
    if (value < 10) {
      return (`0${ value }`);
    }
    return value.toString();
  }

  static getSecondsTwoDigits(date) {
    const value = date.getSeconds();
    if (value < 10) {
      return (`0${ value }`);
    }
    return value.toString();
  }

  static getMonthsTwoDigits(date) {
    const value = date.getMonth() + 1;
    if (value < 10) {
      return (`0${ value }`);
    }
    return value.toString();
  }

  static getYearMonth(date) {
    return `${ date.getFullYear() }${ this.getMonthsTwoDigits(date) }`;
  }

  static addMonth(date) {
    return new Date(date.setMonth(date.getMonth() + 1));
  }

  static subtractMonth(date) {
    return new Date(date.setMonth(date.getMonth() - 1));
  }

  static removeTime(date) {
    return new Date(date.setHours(0, 0, 0, 0));
  }

  /**
   * Convert given date to a given format
   * @param {Object} date the date (can be given as a string) eg: 2000-01-01
   * @param {String} inputFormat date format of the input eg: YYYY-MM-DD 
   * @param {String} outputFormat required format to be returned eg: MMMM D, YYYY
   */
  static convertTimeFormat(date, inputFormat, outputFormat) {
    return date ? moment(date, inputFormat, true).format(outputFormat) : 'Invalid date';
  }

  /**
   * Convert given date to a given format and local timezone
   * @param {String} date the date (can be given as a string) eg: 2000-01-01
   * @param {String} inputFormat date format of the input eg: YYYY-MM-DD 
   * @param {String} outputFormat required format to be returned eg: MMMM D, YYYY
   */
  static convertTimeFormatLocal(date, inputFormat, outputFormat) {
    return date ? moment(date, inputFormat, true).local().format(outputFormat) : 'Invalid date';
  }
}
